import { IModalState, CLEAR_MODAL_CONTENT, SET_MODAL_CONTENT, TAction } from 'store/modal/types';

const initialState: IModalState = {
  content: null,
  visible: false,
  optionModal: false,
};

export default function(state = initialState, action: TAction) {
  switch (action.type) {
    case CLEAR_MODAL_CONTENT: {
      return initialState;
    }

    case SET_MODAL_CONTENT: {
      const { content, optionModal } = action;
      return {
        content,
        visible: true,
        optionModal,
      };
    }

    default: {
      return state;
    }
  }
}
